import { Cascade } from 'types';

import { createCrudApi } from './crud.api';

const path = '/cascades';

const crudApi = createCrudApi<Cascade>(path);

export const cascadesApi = {
  ...crudApi,
};
